import { Box, IconButton, Tooltip } from '@chakra-ui/react';
import { useSelector } from 'react-redux';
import { Link } from 'react-router-dom';

import { useServicesDashboard } from 'context/ServicesDashboardContext';
import { classNames } from 'utils/classNames';
import { getTruncatedText, isTruncated } from '../Vendor/helper';

import Text from 'components/v4/Text';
import { IconComponent } from '../IconComponent';

export default function DirectRoutingCustomStatus({
    serviceObj,
    accountScope,
    handleActions,
}) {
    const { DirectRouting: cardStatus } = useServicesDashboard();
    const { handleGrantAccess } = handleActions;
    const DrEdit = `/services/directrouting/${serviceObj?.id}/edit`;
    const canEdit = accountScope >= 40 && cardStatus?.showEdit;
    const canGrantAccess =
        cardStatus?.grantAccess && serviceObj?.authPolicy !== 0;

    const handleClick =
        cardStatus?.actionIconTooltip === 'Grant Access'
            ? handleGrantAccess
            : null;

    const { darkMode } = useSelector((state) => state.settings);

    if (!serviceObj) return <Text>...</Text>;

    if (cardStatus?.tooltipIcon) {
        return (
            <Box
                sx={{
                    flexDirection: 'row',
                    display: 'flex',
                    justifyContent: 'flex-end',
                }}
                className="truncate">
                <Tooltip
                    hasArrow
                    label={getTruncatedText(cardStatus.statusLabel)}
                    placement="bottom-end">
                    <span
                        className={classNames(
                            isTruncated(cardStatus.statusLabel)
                                ? 'truncate'
                                : '',
                            'ml-20',
                            darkMode ? 'text-white' : 'text-black',
                        )}>
                        {cardStatus?.statusLabel}
                    </span>
                </Tooltip>

                <span className="mx-1 inline-flex flex-shrink-0 self-center">
                    <Tooltip
                        label={
                            cardStatus?.tooltip ||
                            cardStatus?.statusDisplay?.statusDisplayExtended
                        }
                        hasArrow
                        placement="bottom">
                        <IconButton
                            icon={
                                <IconComponent
                                    icon={cardStatus?.tooltipIcon}
                                    color={darkMode ? 'white' : 'black'}
                                    className={
                                        cardStatus?.tooltipIcon === 'Spinner'
                                            ? 'animate-spin'
                                            : ''
                                    }
                                />
                            }
                            size="xs"
                            bg="transparent"
                            _hover={{ bg: 'transparent' }}
                            _focus={{ bg: 'transparent' }}
                            _active={{ bg: 'transparent' }}
                            className="!cursor-default"
                        />
                    </Tooltip>
                </span>
                {cardStatus?.actionIcon === 'Settings' && canGrantAccess && (
                    <span className="my-auto inline-flex flex-shrink-0 self-center">
                        <Tooltip
                            label={cardStatus?.actionIconTooltip}
                            hasArrow
                            placement="bottom">
                            <IconButton
                                icon={
                                    <IconComponent
                                        icon="Settings"
                                        color={darkMode ? 'white' : 'black'}
                                    />
                                }
                                size="xs"
                                bg="transparent"
                                _hover={{
                                    bg: 'transparent',
                                }}
                                _focus={{
                                    bg: 'transparent',
                                }}
                                _active={{ bg: 'transparent' }}
                                onClick={handleClick}
                            />
                        </Tooltip>
                    </span>
                )}
                {cardStatus?.actionIcon === 'Edit' && canEdit && (
                    <span className="my-auto inline-flex flex-shrink-0 self-center">
                        <Tooltip
                            label={cardStatus?.actionIconTooltip}
                            hasArrow
                            placement="bottom">
                            <Link
                                to={DrEdit}
                                state={serviceObj}
                                className="hover:text-inherit hover:!no-underline">
                                <IconButton
                                    icon={
                                        <IconComponent
                                            icon="Edit"
                                            color={darkMode ? 'white' : 'black'}
                                        />
                                    }
                                    size="xs"
                                    bg="transparent"
                                    _hover={{
                                        bg: 'transparent',
                                    }}
                                    _focus={{
                                        bg: 'transparent',
                                    }}
                                    _active={{ bg: 'transparent' }}
                                />
                            </Link>
                        </Tooltip>
                    </span>
                )}
            </Box>
        );
    }

    return <Text>{cardStatus?.statusLabel}</Text>;
}
